const VALIDATION_ERROR_MESSAGES = {
	MISSING_MAPPING_NAME: "Please fill the Mapping Name for all mappings.",
	MISSING_MAPPING_ELEMENT: "Please select the Mapping Element for all mappings.",
	DUPLICATED_MAPPING_NAME: "Mapping Name must be unique.",
	INVALID_MAPPING_NAME_CHARACTERS: "Mapping Name cannot contain any of these characters: < > ? \\ * | /",
	MISSING_VERSION_NAME: "Please add a Mapping Name with value \"versionName\".",
};
const INVALID_MAPPING_NAME_CHARACTERS_REGEX = /[<>?\\*|/]/;
const normalizeMappingName = (mappingName = "") => mappingName.trim().toLowerCase();

export const getValidationFieldErrors = (feedMappings = []) => {
	const missingMappingNameRowIndexes = [];
	const missingMappingElementRowIndexes = [];
	const invalidMappingNameCharacterRowIndexes = [];
	const mappingNameToRowIndexes = {};

	feedMappings.forEach((mapping, rowIndex) => {
		const mappingName = mapping?.name?.trim();
		const normalizedMappingName = normalizeMappingName(mapping?.name);
		const mappingElement = mapping?.mappingElement;

		if (!mappingName) {
			missingMappingNameRowIndexes.push(rowIndex);
		} else {
			mappingNameToRowIndexes[normalizedMappingName] = mappingNameToRowIndexes[normalizedMappingName] || [];
			mappingNameToRowIndexes[normalizedMappingName].push(rowIndex);
		}

		if (mappingName && INVALID_MAPPING_NAME_CHARACTERS_REGEX.test(mappingName)) {
			invalidMappingNameCharacterRowIndexes.push(rowIndex);
		}

		if (!mappingElement) {
			missingMappingElementRowIndexes.push(rowIndex);
		}
	});

	const duplicatedMappingNameRowIndexes = Object.values(mappingNameToRowIndexes)
		.filter(indexes => indexes.length > 1)
		.flat();

	const mappingNameRowIndexesWithErrors = Array.from(new Set([
		...missingMappingNameRowIndexes,
		...duplicatedMappingNameRowIndexes,
		...invalidMappingNameCharacterRowIndexes,
	]));

	return {
		mappingNameRowIndexesWithErrors,
		mappingElementRowIndexesWithErrors: missingMappingElementRowIndexes,
	};
};

export const getValidationMessages = (feedMappings = []) => {
	const mappingNames = feedMappings.map(mapping => mapping?.name?.trim()).filter(Boolean);
	const normalizedMappingNames = mappingNames.map(normalizeMappingName);
	const hasMissingMappingName = feedMappings.some(mapping => !mapping?.name?.trim());
	const hasMissingMappingElement = feedMappings.some(mapping => !mapping?.mappingElement);
	const hasVersionNameMapping = normalizedMappingNames.includes("versionname");
	const duplicatedMappingNames = new Set(
		normalizedMappingNames.filter((mappingName, index) => normalizedMappingNames.indexOf(mappingName) !== index)
	);
	const hasInvalidMappingNameCharacters = mappingNames.some(
		mappingName => INVALID_MAPPING_NAME_CHARACTERS_REGEX.test(mappingName)
	);
	const messages = [];

	if (hasMissingMappingName) {
		messages.push(VALIDATION_ERROR_MESSAGES.MISSING_MAPPING_NAME);
	}
	if (hasMissingMappingElement) {
		messages.push(VALIDATION_ERROR_MESSAGES.MISSING_MAPPING_ELEMENT);
	}
	if (duplicatedMappingNames.size > 0) {
		messages.push(VALIDATION_ERROR_MESSAGES.DUPLICATED_MAPPING_NAME);
	}
	if (hasInvalidMappingNameCharacters) {
		messages.push(VALIDATION_ERROR_MESSAGES.INVALID_MAPPING_NAME_CHARACTERS);
	}
	if (!hasVersionNameMapping) {
		messages.push(VALIDATION_ERROR_MESSAGES.MISSING_VERSION_NAME);
	}

	return messages;
};
